module.exports = __webpack_public_path__ + "img/MED_POULTRY@300x.69b8c19c.png";